import styled from "styled-components";

export const Container = styled.div `
    p{
        font-size: 13px;
        color: #B8B8D4;
    }
    h1{
        margin: 0;
        padding: 0;
        font-size: 26px;
    }
    hr{
        height: 1px;
        border: 0;
        background-color: #16195C;
        margin: 30px 0;
    }

    label{
        font-size: 14px;
    }

    .form-control {
        border-radius: 2rem;
        border: 0;
        padding: .9rem 1.3rem;
        background: #efefef;
        box-shadow: inset 7px 7px 14px #cbcbcb,
            inset -7px -7px 14px #ffffff;
    }

    .btn {
        padding: 1rem;
        border-radius: 1.9rem;
        box-shadow:  7px 7px 14px #cbcbcb,
             -7px -7px 14px #ffffff;
    }

    .btn:hover,focus {
        box-shadow: 7px 7px 14px #a1a1a1, -7px -7px 14px #c9c9c9;
    }

    .back {
        border-radius: 1.9rem;
        width: 3rem;
        height: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(145deg, #ffffff, #d7d7d7);
box-shadow:  7px 7px 14px #cbcbcb,
             -7px -7px 14px #ffffff;
        color: #555;
    }

    .back:hover,focus {
        background: linear-gradient(145deg, #d7d7d7, #ffffff);
box-shadow:  7px 7px 14px #cbcbcb,
             -7px -7px 14px #ffffff;
    }

    .input-group-text {
        padding: 0 .75rem;
        font-weight: 700;
        border-radius: 1.9rem 0 0 1.9rem!important;
    }
`;